import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector, RootStateOrAny } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation, usePermissions } from "hooks";
import { translations } from "./translations";

import {
  PaginateDocumentCategoryActions,
  PaginateDocumentCategoryState,
} from "store/ducks/settings/document-category";

import { SelectedFilterActions, SelectedFilterState } from "store/ducks/filter";

import * as S from "./styles";
import {
  MainContainer,
  Paginator,
  Search,
  MenuSelector,
} from "components/shared";
import { GridDocumentCategory } from "components/settings";

export const ListDocumentCategory: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { checkUserPermission } = usePermissions();
  const { getTranslation } = useTranslation(translations);
  const [query, setQuery] = useState({
    search: "",
    limit: 10,
    page: 1,
  });
  const { data, loading, pagination } = useSelector<RootStateOrAny>(
    (state) => state.paginateDocumentCategory
  ) as PaginateDocumentCategoryState;

  const { data: dataFilter } = useSelector<RootStateOrAny>(
    (state) => state.selectedFilter
  ) as SelectedFilterState;

  const handleSearchChange = useCallback(
    (value: any) => {
      const data = {
        ...dataFilter,
        search: value,
        page: 1,
      };
      dispatch(SelectedFilterActions.success(data));
      setQuery((state) => ({ ...state, data }));
    },
    [setQuery, dispatch, dataFilter]
  );

  const handlePageChange = useCallback(
    (value: any) => {
      const data = {
        ...dataFilter,
        page: value,
      };
      dispatch(SelectedFilterActions.success(data));
      setQuery((state) => ({ ...state, data }));
    },
    [setQuery, dispatch, dataFilter]
  );

  const getData = useCallback(() => {
    dispatch(
      PaginateDocumentCategoryActions.request({ ...query, ...dataFilter })
    );
  }, [dispatch, query, dataFilter]);

  useEffect(() => {
    getData();
  }, [getData]);
  return (
    <MainContainer>
      <S.PageHeader>
        <h1>
          <S.IconSetting />
          {getTranslation("configuracoes")}
          <MenuSelector page="document-category" />
          {loading && <S.LoadingPage />}
        </h1>
        <Search onSearch={handleSearchChange} />

        {checkUserPermission("insertDocCategory") && (
          <S.ButtonMini
            onClick={() => history.push("/settings/document-category/new")}
          >
            {getTranslation("novoCategoria")}
          </S.ButtonMini>
        )}
      </S.PageHeader>
      <S.PageContent>
        <GridDocumentCategory categories={data} />
        <Paginator
          pagination={pagination}
          onPageChange={handlePageChange}
          loading={loading}
        />
      </S.PageContent>
    </MainContainer>
  );
};
